import Autocomplete from '@mui/material/Autocomplete';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { type FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

export const LANGUAGE_OPTIONS = [
  'Arabic',
  'Bengali',
  'Bulgarian',
  'Burmese',
  'Cantonese',
  'Catalan',
  'Croatian',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Estonian',
  'Filipino (Tagalog)',
  'Finnish',
  'French',
  'German',
  'Greek',
  'Gujarati',
  'Hebrew',
  'Hindi',
  'Hungarian',
  'Icelandic',
  'Indonesian',
  'Italian',
  'Japanese',
  'Javanese',
  'Kannada',
  'Khmer',
  'Korean',
  'Latvian',
  'Lithuanian',
  'Malay',
  'Malayalam',
  'Mandarin Chinese',
  'Marathi',
  'Norwegian',
  'Pashto',
  'Persian (Farsi)',
  'Polish',
  'Portuguese',
  'Punjabi',
  'Romanian',
  'Russian',
  'Serbian',
  'Sinhala',
  'Slovak',
  'Slovenian',
  'Spanish',
  'Swahili',
  'Swedish',
  'Tamil',
  'Telugu',
  'Thai',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Vietnamese',
];

type TProps = Omit<TextFieldProps, 'name'> & {
  name: string;
};

export const RHFLanguage: FC<TProps> = ({ name, helperText, label, placeholder, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <Autocomplete
          options={LANGUAGE_OPTIONS}
          value={field.value || null}
          onChange={(_, value) => field.onChange(value ?? '')}
          fullWidth
          freeSolo
          autoSelect
          renderInput={params => (
            <TextField
              {...params}
              {...rest}
              fullWidth
              label={label}
              placeholder={placeholder ?? 'Select or type your native language'}
              error={!!error}
              helperText={error ? error.message : helperText}
              sx={{ '& .MuiInputBase-root': { height: 60 } }}
            />
          )}
        />
      )}
    />
  );
};
